// src/Components/NewBusinessInsights/BusinessInsightsContent/Reports/Discounts/hooks/useDiscounts.js
import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useDiscountsReport = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.discountsReport, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getDiscountsReport(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        clinicDiscounts: res.data.data.clinic_discounts,
        providerDiscounts: res.data.data.provider_discounts,
      };
      return composeResponse;
    },
    options,
  );
};
